if (!customElements.get("ingredients-popup")) {
  customElements.define(
    "ingredients-popup",
    class IngredientsPopup extends HTMLElement {
      constructor() {
        super();
        this.clientName = "pillowtalk derm";
        this.bearerToken =
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MmZhZWNjMmJkZmJlOTAwMjFmNWYzMTgiLCJzdG9yZVVybCI6Imh0dHBzOi8vcGlsbG93dGFsa2Rlcm0uY29tLyIsImlhdCI6MTY2MTM3NTg2MH0.RAPyi49pN52xP3K1jCXXXI94Az-TqOmDBg-v3ET0hjM";
        this.isIngredientsHidden = true;
      }

      connectedCallback() {
        this.cacheElements();
        this.addEventListeners();
      }

      cacheElements() {
        this.popupButtons = this.querySelectorAll(".js-ingredients-popup-button");
        this.backButton = this.querySelector(".js-ingredients-popup-button-back");
        this.sku = this.querySelector(".js-current_variant-sku").getAttribute(
          "data-sku"
        );
        this.title = this.querySelector(".js-ingredients-popup-container").getAttribute(
          "data-title"
        );
        this.popupContainer = this.querySelector(".js-ingredients-popup-container");
        this.popupInner = this.querySelector(".js-ingredients-popup-inner");
        this.popupIngredients = this.querySelector(".js-ingredients-popup-ingredients");
        this.popupIngredient = this.querySelector(".js-ingredients-popup-ingredient");
      }

      addEventListeners() {
        this.popupButtons.forEach((button) => {
          button.addEventListener("click", () => this.togglePopup(button));
        });

        this.backButton.addEventListener("click", () => this.showIngredientsList());
      }

      togglePopup(button) {
        if (this.isIngredientsHidden) {
          this.lastFocusedElement = document.activeElement;
          this.popupButtons.forEach((button) => {
            button.setAttribute("aria-expanded", "true");
          });
          this.showPopup();
        } else {
          this.popupButtons.forEach((button) => {
            button.setAttribute("aria-expanded", "false");
          });
          this.hidePopup();
        }
        this.isIngredientsHidden = !this.isIngredientsHidden;

        if (this.popupContainer.classList.contains("active-popup")) {
          this.fetchIngredients();
        }
      }

      showPopup() {
        this.popupContainer.removeAttribute("inert");
        this.popupIngredients.classList.add("active-text");
        this.popupIngredient.classList.remove("active-text");
        this.popupContainer.classList.add("active-popup");
            // Apply focus trap
            console.log(this.popupIngredient, 'hello')
            trapFocus(this.popupContainer, this.lastFocusedElement);
      }

      hidePopup() {
        this.popupContainer.classList.remove("active-popup");
        this.popupContainer.setAttribute("inert", '');
        setTimeout(() => {
          this.popupIngredients.classList.remove("active-text");
          this.backButton.classList.remove("active-text");
        }, 1000);
                    // remove focus trap
                    removeTrapFocus(this.popupContainer);
      }

      fetchIngredients() {
        const url = `https://clickable-api.clearforme.com/api/app/products/details/v2?sku=${this.sku}&clientname=${this.clientName}`;
        fetch(url, {
          method: "GET",
          headers: {
            Authorization: this.bearerToken,
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (!response.ok) throw new Error("Network response was not ok");
            return response.json();
          })
          .then((data) => this.renderIngredients(data))
          .catch((error) => console.error(error));
      }

      renderIngredients(data) {
        const ingredientsList = data.productIngredients;
        let ingredientsListHTML = `<h2>${this.title}</h2>`;

        ingredientsList.forEach((pIngredient) => {
          const ingredientGroups = pIngredient.ingredientGroup;

          ingredientsListHTML += `<h3><strong>${pIngredient.component}</strong></h3>`;

          ingredientGroups.forEach((group) => {
            group.ingredients.forEach((ingredient) => {
              const name = ingredient.ingredientName;
              ingredientsListHTML += `<span class="api_ing" data-ingredient="${name}" data-productIngredientId="${ingredient.productIngredientId}" data-cfmIngredientId="${ingredient.cfmIngredientId}">${name}</span>,&nbsp;`;
            });
          });
        });

        this.popupIngredients.innerHTML = ingredientsListHTML;
        this.addIngredientClickEvents();
      }

      addIngredientClickEvents() {
        this.popupIngredients.addEventListener("click", (event) => {
          const ingredient = event.target.closest(".api_ing");
          if (ingredient) this.fetchIngredientDetails(ingredient);
        });
      }

      fetchIngredientDetails(ingredient) {
        const productIngredientId = ingredient.getAttribute("data-productIngredientId");
        const cfmIngredientId = ingredient.getAttribute("data-cfmIngredientId");

        const url = `https://clickable-api.clearforme.com/api/app/ingredients/definition/v2?clientname=${this.clientName}&productIngredientId=${productIngredientId}&cfmIngredientId=${cfmIngredientId}`;

        fetch(url, {
          method: "GET",
          headers: {
            Authorization: this.bearerToken,
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (!response.ok) throw new Error("Network response was not ok");
            return response.json();
          })
          .then((data) => this.renderIngredientDetails(data))
          .catch((error) => console.error(error));
      }

      renderIngredientDetails(data) {
        const ingredientHTML = `
          <div id="js-ingredients-popup-single-ingredient">
            <h3>${data.ingredientName}</h3>
            <h4><b>Definition</b></h4><p>${data.definition}</p>
            <h4><b>Attributes</b></h4><p>${data.functions.map((val) => val.attribute).join(", ")}</p>
          </div>`;
        this.popupIngredient.innerHTML = ingredientHTML;
        this.popupIngredients.classList.remove("active-text");
        this.popupIngredient.classList.add("active-text");
        console.log(this.backButton)
        this.backButton.classList.add("active-text");
      }

      showIngredientsList() {
        this.backButton.classList.remove("active-text");
        this.popupIngredients.classList.add("active-text");
        this.popupIngredient.classList.remove("active-text");
      }
    }
  );
}
